import { Options } from '@frontend/fetch';
import { SchedulerServiceV3 } from '@frontend/schema';
import {
  AppointmentStatusWriteBackApiType,
  AppointmentWriteBackApiType,
  CreateAppointmentTypeApiType,
  CreateCalendarEventApiType,
  CreateScheduleEntriesApiType,
  CreateScheduleRequestApiType,
  DeleteAppointmentTypesApiType,
  DeleteCalendarEventsApiType,
  GetCalendarEventApiType,
  GetFeatureFlagStatusApiType,
  GetOperatoryApiType,
  ListAppointmentTypesApiType,
  ListAppointmentTypesMultiLocationApiType,
  ListCalendarAvailabilitiesApiType,
  ListCalendarEventsApiType,
  ListCalendarEventsByOwnerApiType,
  ListCalendarEventsMultiApiType,
  ListOperatoriesApiType,
  ListOperatoriesMultiLocationApiType,
  ListScheduleEntriesApiType,
  ListSourceTenantsApiType,
  PersonWriteBackApiType,
  UpdateAppointmentTypeApiType,
  UpdateCalendarEventApiType,
  UpdateOperatoryApiType,
  UpdateCalendarEventStatusApiType,
  UpdateScheduleEntriesApiType,
  ListScheduleRequestsApiType,
} from './types';

export const getAppointmentTypes = async (
  req: ListAppointmentTypesApiType['input']
): Promise<ListAppointmentTypesApiType['output']> => SchedulerServiceV3.ListAppointmentTypes(req);

export const updateAppointmentType = async (
  req: UpdateAppointmentTypeApiType['input']
): Promise<UpdateAppointmentTypeApiType['output']> => SchedulerServiceV3.UpdateAppointmentType(req);

export const createAppointmentType = async (
  req: CreateAppointmentTypeApiType['input']
): Promise<CreateAppointmentTypeApiType['output']> => SchedulerServiceV3.CreateAppointmentType(req);

export const deleteAppointmentTypes = async (
  req: DeleteAppointmentTypesApiType['input']
): Promise<DeleteAppointmentTypesApiType['output']> => SchedulerServiceV3.DeleteAppointmentTypes(req);

export const getAppointmentTypesForMultiLocation = async (
  req: ListAppointmentTypesMultiLocationApiType['input']
): Promise<ListAppointmentTypesMultiLocationApiType['output']> => SchedulerServiceV3.ListAppointmentTypesMulti(req);

export const listScheduleEntries = async (
  req: ListScheduleEntriesApiType['input']
): Promise<ListScheduleEntriesApiType['output']> => SchedulerServiceV3.ListSchedules(req);

export const createSchedulerEntries = async (
  req: CreateScheduleEntriesApiType['input']
): Promise<CreateScheduleEntriesApiType['output']> => SchedulerServiceV3.CreateSchedule(req);

export const updateSchedulerEntries = async (
  req: UpdateScheduleEntriesApiType['input']
): Promise<UpdateScheduleEntriesApiType['output']> => SchedulerServiceV3.UpdateSchedule(req);

// Calendar Events
export const listCalendarEvents = async (
  req: ListCalendarEventsApiType['input']
): Promise<ListCalendarEventsApiType['output']> => SchedulerServiceV3.ListCalendarEvents(req);

export const listCalendarEventsMulti = async (
  req: ListCalendarEventsMultiApiType['input']
): Promise<ListCalendarEventsMultiApiType['output']> => SchedulerServiceV3.ListCalendarEventsMulti(req);

export const listCalendarEventsByOwner = async (
  req: ListCalendarEventsByOwnerApiType['input']
): Promise<ListCalendarEventsByOwnerApiType['output']> => SchedulerServiceV3.ListCalendarEventsByOwner(req);

export const getCalendarEvent = async (
  req: GetCalendarEventApiType['input']
): Promise<GetCalendarEventApiType['output']> => SchedulerServiceV3.GetCalendarEvent(req);

export const createCalendarEvent = async (
  req: CreateCalendarEventApiType['input']
): Promise<CreateCalendarEventApiType['output']> => SchedulerServiceV3.CreateCalendarEvent(req);

export const updateCalendarEvent = async (
  req: UpdateCalendarEventApiType['input']
): Promise<UpdateCalendarEventApiType['output']> => SchedulerServiceV3.UpdateCalendarEvent(req);

export const deleteCalendarEvents = async (
  req: DeleteCalendarEventsApiType['input']
): Promise<DeleteCalendarEventsApiType['output']> => SchedulerServiceV3.DeleteCalendarEvents(req);

export const updateCalendarEventStatus = async (
  req: UpdateCalendarEventStatusApiType['input']
): Promise<UpdateCalendarEventStatusApiType['output']> => SchedulerServiceV3.UpdateCalendarEventStatus(req);

export const listOperatories = async (
  req: ListOperatoriesApiType['input']
): Promise<ListOperatoriesApiType['output']> => SchedulerServiceV3.ListOperatories(req);

export const listOperatoriesForMultiLocation = async (
  req: ListOperatoriesMultiLocationApiType['input']
): Promise<ListOperatoriesMultiLocationApiType['output']> => SchedulerServiceV3.ListOperatoriesMulti(req);

export const updateOperatory = async (
  req: UpdateOperatoryApiType['input']
): Promise<UpdateOperatoryApiType['output']> => SchedulerServiceV3.UpdateOperatory(req);

export const getOperatory = async (req: GetOperatoryApiType['input']): Promise<GetOperatoryApiType['output']> =>
  SchedulerServiceV3.GetOperatory(req);

export const getListCalendarAvailabilities = async (
  req: ListCalendarAvailabilitiesApiType['input'],
  options?: Options
): Promise<ListCalendarAvailabilitiesApiType['output']> => SchedulerServiceV3.ListCalendarAvailabilities(req, options);
export const appointmentWriteback = async (
  req: AppointmentWriteBackApiType['input']
): Promise<AppointmentWriteBackApiType['output']> => SchedulerServiceV3.AppointmentWriteBack(req);

export const appointmentStatusWriteback = async (
  req: AppointmentStatusWriteBackApiType['input']
): Promise<AppointmentStatusWriteBackApiType['output']> => SchedulerServiceV3.AppointmentStatusWriteBack(req);

export const personWriteback = async (
  req: PersonWriteBackApiType['input']
): Promise<PersonWriteBackApiType['output']> => SchedulerServiceV3.PersonWriteBack(req);

export const listSourceTenants = async (
  req: ListSourceTenantsApiType['input']
): Promise<ListSourceTenantsApiType['output']> => SchedulerServiceV3.ListSourceTenants(req);

export const getFeatureFlagStatus = (req: GetFeatureFlagStatusApiType['input'], options?: Options) => {
  return SchedulerServiceV3.FeatureFlagStatus(req, options);
};

export const createScheduleRequest = async (
  req: CreateScheduleRequestApiType['input'],
  options?: Options
): Promise<CreateScheduleRequestApiType['output']> => SchedulerServiceV3.CreateBookingSubmission(req, options);

export const listScheduleRequests = async (
  req: ListScheduleRequestsApiType['input']
): Promise<ListScheduleRequestsApiType['output']> => SchedulerServiceV3.ListBookingSubmissions(req);
